import type { CallInfo, ClientState } from "@rhema/client";
import { chatTitle, firstName } from "../data/view";

/** The display name of a member of the call's chat. */
export function memberName(state: ClientState, chatId: string, userId: string | null | undefined): string {
  if (!userId) return "Someone";
  if (userId === state.me?.id) return state.me.display_name;
  const m = state.chats[chatId]?.members.find((x) => x.user.id === userId);
  return m?.user.display_name ?? "Someone";
}

/** "Amara" for a direct call, or the group name for a group call. */
export function callTitle(state: ClientState, call: Pick<CallInfo, "chat_id">): string {
  const chat = state.chats[call.chat_id];
  return chat ? chatTitle(chat, state.me?.id) : "Call";
}

export function isGroupCall(state: ClientState, chatId: string): boolean {
  return state.chats[chatId]?.kind === "group";
}

export function callerLine(state: ClientState, call: CallInfo): string {
  const kind = call.media === "video" ? "video call" : "voice call";
  if (isGroupCall(state, call.chat_id))
    return `${firstName(memberName(state, call.chat_id, call.started_by))} is starting a group ${kind}`;
  return `Incoming ${kind}`;
}
